import React from "react";
import SimpleCRUD from "../../components/SimpleCRUD";

export default function Shift() {
  return (
    <SimpleCRUD
      title="Management Shift / Jam Kerja"
      endpoint="/shifts"
      testidPrefix="shift"
      fields={[
        { key: "nama", label: "Nama Shift", required: true },
        { key: "jam_masuk", label: "Jam Masuk", type: "time", required: true },
        { key: "jam_pulang", label: "Jam Pulang", type: "time", required: true },
        { key: "toleransi_menit", label: "Toleransi Terlambat (menit)", type: "number", default: 15 },
        { key: "potongan_jam", label: "Potongan Gaji (jam)", type: "number", default: 0 },
        { key: "keterangan", label: "Keterangan", type: "textarea" },
        { key: "status_aktif", label: "Status", type: "checkbox", default: true, checkboxLabel: "Aktif" },
      ]}
    />
  );
}
